import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { PaperSize } from "../../providers/escpos-ticket";
import { BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";

import { BvRadioGroupComponent, BvRadioComponent } from "../../design-system/primitives/radio.component";
import { FormsModule } from "@angular/forms";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

/**
 * One-time prompt that asks the user which paper width a freshly-paired
 * printer uses. Mounted at the app shell and driven declaratively by
 * PaperSizeService — the service flips [open] and the user's pick comes
 * back via (chosen).
 *
 * Backdrop / escape close are disabled: the only way to dismiss is to
 * confirm a size. Default selection is 80mm since that's what most modern
 * Epson-compatibles ship with.
 */
@Component({
    selector: "app-paper-size-prompt",
    templateUrl: "./paper-size-prompt.component.html",
    styleUrls: ["./paper-size-prompt.component.scss"],
    imports: [BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvRadioGroupComponent, FormsModule, BvRadioComponent, BvDialogFooterComponent, BvButtonComponent, TranslateModule]
})
export class PaperSizePromptComponent implements OnChanges {
  @Input() open = false;
  @Input() deviceName = "";
  @Output() chosen = new EventEmitter<PaperSize>();

  selected: PaperSize = "80mm";

  ngOnChanges(changes: SimpleChanges): void {
    // Reset to 80mm default each time the prompt is reopened so a previous
    // pick on a different device doesn't bleed through.
    if (changes.open && changes.open.currentValue === true) {
      this.selected = "80mm";
    }
  }

  confirm(): void {
    this.chosen.emit(this.selected);
  }
}
